import React from 'react';
import { Grid } from '@mui/material';

import { AuthorizerContext } from 'app/providers/acl/AclProvider';
import { Icon, useSettings } from 'app/main/components';
import {
	DetailsSectionImage,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';

// import UsersDetailsSectionFiltersSaved from '../sections/UsersDetailsSectionFiltersSaved';
import UsersDetailsSectionInfo from '../sections/UsersDetailsSectionInfo';
import UsersDetailsSectionLoginSettings from '../sections/UsersDetailsSectionLoginSettings';
import UsersDetailsSectionPermissions from '../sections/UsersDetailsSectionPermissions';
import UsersDetailsSectionReports from '../sections/UsersDetailsSectionReports';
import UsersDetailsSectionSystemInfo from '../sections/UsersDetailsSectionSystemInfo';
import UsersDetailsSectionFiltersSaved from '../sections/UsersDetailsSectionFiltersSaved';

export default function UsersDetailsTab(props: DetailsPageContentProps) {
	const { t } = useSettings();
	const authorizer = React.useContext(AuthorizerContext);

	const canUpdateUsers = authorizer.can('update', 'users');

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<UsersDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					{!props.isAdd && canUpdateUsers && (
						<Grid size={{ md: 6, xs: 12 }}>
							<Grid container spacing={2}>
								<Grid size={12}>
									<UsersDetailsSectionPermissions isEdit={props.isEdit} />
								</Grid>
								<Grid size={12}>
									<UsersDetailsSectionReports model={props.model} isEdit={props.isEdit} />
								</Grid>
							</Grid>
						</Grid>
					)}
					<Grid size={{ md: 6, xs: 12 }}>
						{!props.isEdit ? (
							<UsersDetailsSectionFiltersSaved userUid={props.model.user_uid} />
						) : (
							<DetailsSectionImage
								title={t('USERS_AVATAR_SECTION')}
								subheader={t('USERS_AVATAR_SUBHEADER')}
								isEdit
								fieldName="user_avatar"
								fileName={props.model.user_uid}
								path={`users\\${props.model.user_uid}`}
								value={props.model.user_avatar}
								// grabberProps={{
								// 	defaultSearch: `${props.model.user_name || ''} ${props.model.user_surname || ''}`
								// }}
								sendChange={props.sendFilesChange}
							/>
						)}
					</Grid>
				</Grid>
			</Grid>
			<Grid size={{ lg: 4, xs: 12 }}>
				<Grid container spacing={2}>
					{props.isAdd ? (
						<Grid size={12}>
							<UsersDetailsSectionLoginSettings
								model={props.model}
								isEdit={props.isEdit}
								sendChange={props.sendChange}
							/>
						</Grid>
					) : (
						<Grid size={12}>
							<UsersDetailsSectionSystemInfo
								model={props.model}
								isEdit={props.isEdit}
								sendChange={props.sendChange}
							/>
						</Grid>
					)}
				</Grid>
			</Grid>
		</Grid>
	);
}
